@if (showLoadingIndicator) {
<div class="center-item">
  <div class="loader"></div>
</div>
}

<router-outlet></router-outlet>

<app-update-prompt></app-update-prompt>
